import { useEffect, useState } from "@wordpress/element";
import Typography from "../Typography";
import { FaCheck } from "react-icons/fa";

const elementosCheckbox = [
    {name: "pequeno", classes: 'w-3 h-3 after:border-b-[0.1em] after:border-r-[0.1em]'},
    {name: "medio", classes: 'w-4 h-4 after:border-b-[0.2em] after:border-r-[0.2em]'},
    {name: "grande", classes: 'w-5 h-5 after:border-b-[0.3em] after:border-r-[0.3em]'}
]
//TODO: add param geral
export default function Checkbox({ checked = false, label, disabled = false, onChange, value, component="grande", select=false , children, className, onClick }) {
    const [element, setElement] = useState(elementosCheckbox.find(e => e.name == component))

    useEffect(() => {
        setElement(elementosCheckbox.find(e => e.name == component))
    }, [component])

    return (
        <label className={`justify-start items-center gap-2 inline-flex ${className}`}>
            <input type="checkbox" className="peer sr-only" name="framework" disabled={disabled} onClick={onClick} value={value} checked={checked} onChange={(a) => onChange(a.target.value)} />

            <div className={`${element.classes} bg-text-contrast ${select ? "rounded-full" : "rounded"} 
            border-solid border border-text-inactive flex items-center justify-center cursor-pointer 
            ${!disabled && "hover:border-primary-medium"}
            peer-checked:border-primary-medium peer-checked:bg-primary-medium
            peer-checked:after:opacity-100 peer-checked:after:rotate-45`}>
                {checked && <FaCheck className="text-text-contrast w-3 h-3"/>}
            </div>
            {label && <Typography component={"body1-semibold"}>{label}</Typography>}
            {children}
        </label>

    )
}